import { Clock, Mail, MessageCircle } from "lucide-react";
import { Navbar } from "@/components/landing/Top";
import { Footer } from "@/components/landing/Bottom";
import { ContactForm } from "@/components/contact/ContactForm";
import { useApp } from "@/lib/i18n";

export default function Contact() {
  const { L, brand } = useApp();
  const info = [
    [Mail, L("Emel sokongan", "Support email"), <a href={`mailto:${brand.support_email}`} className="font-semibold text-violet-700" data-testid="contact-support-email">{brand.support_email}</a>],
    [Clock, L("Waktu respons", "Response time"), L("1–2 hari bekerja (Isnin–Jumaat)", "1–2 working days (Mon–Fri)")],
    [MessageCircle, L("Bahasa", "Language"), L("Bahasa Melayu & English", "Malay & English")],
  ];
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="contact-page">
      <Navbar />
      <main className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-[2fr_3fr] lg:px-8 lg:py-24">
        <div>
          <p className="text-sm font-semibold uppercase tracking-wider text-violet-700">{L("Hubungi Kami", "Contact Us")}</p>
          <h1 className="mt-3 text-4xl font-extrabold tracking-tight sm:text-5xl">{L("Ada soalan? Kami sedia membantu.", "Questions? We're here to help.")}</h1>
          <p className="mt-5 text-base text-slate-600">{L("Pertanyaan pembayaran, langganan, masalah teknikal atau cadangan — hantar mesej dan pasukan kami akan membalas melalui emel.", "Payment, subscription, technical issues or suggestions — send a message and our team will reply by email.")}</p>
          <div className="mt-10 space-y-5">
            {info.map(([Icon, label, value]) => (
              <div key={label} className="flex items-start gap-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-violet-50 text-violet-600"><Icon size={20} /></span>
                <div><p className="text-xs font-semibold uppercase tracking-wide text-slate-400">{label}</p><div className="mt-0.5 text-sm text-slate-800">{value}</div></div>
              </div>
            ))}
          </div>
        </div>
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
